module.exports = __webpack_public_path__ + "static/media/steam-social-media-svgrepo-com (1).b0c64b35.svg";